import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import LandingPage from "./pages/LandingPage";
import TrainingDetail from "./pages/TrainingDetail";
import RegisterPage from "./pages/RegisterPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import BookPurchase from "./pages/BookPurchase";
import BookPurchaseSuccess from "./pages/BookPurchaseSuccess";
import SimpleBookReader from "./pages/SimpleBookReader";
import FreeBookReader from "./pages/FreeBookReader";
import DownloadBook from "./pages/DownloadBook";
import WebsiteServices from "./pages/WebsiteServices";
import SubscriptionRenewalPage from "./pages/SubscriptionRenewalPage";
import AIToolsPage from "./pages/AIToolsPage";
import CallAnalyzerPage from "./pages/CallAnalyzerPage";
import SeoServicesPage from "./pages/SeoServicesPage";
import PricingPage from "./pages/PricingPage";
import SopStudioPage from "./pages/SopStudioPage";
import SopLibraryPage from "./pages/SopLibraryPage";
import ResumeAtsPage from "./pages/ResumeAtsPage";
import ResumeLibraryPage from "./pages/ResumeLibraryPage";
import CoursesCatalogPage from "./pages/CoursesCatalogPage";
import MyCoursesPage from "./pages/MyCoursesPage";
import CourseDetailPage from "./pages/CourseDetailPage";
import CourseAccessPage from "./pages/CourseAccessPage";
import BundleAccessPage from "./pages/BundleAccessPage";
import LearnPage from "./pages/LearnPage";
import PythonLabPage from "./pages/PythonLabPage";
import PythonLabModulePage from "./pages/PythonLabModulePage";
import PythonLessonPage from "./pages/PythonLessonPage";
import RoadmapPage from "./pages/RoadmapPage";
import TryLessonPage from "./pages/TryLessonPage";
import ProjectShowcasePage from "./pages/ProjectShowcasePage";
import ProjectShowcaseDetailPage from "./pages/ProjectShowcaseDetailPage";
import AIFounderPage from "./pages/AIFounderPage";
import VerifyCertificate from "./pages/VerifyCertificate";
import AuthCallback from "./components/AuthCallback";
import GoogleAuthCallback from "./components/GoogleAuthCallback";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminTrainings from "./pages/admin/AdminTrainings";
import AdminParticipants from "./pages/admin/AdminParticipants";
import AdminCertificates from "./pages/admin/AdminCertificates";
import AdminNews from "./pages/admin/AdminNews";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminWebsiteAnalytics from "./pages/admin/AdminWebsiteAnalytics";
import AdminBooks from "./pages/admin/AdminBooks";
import AdminShansoLearnPage from "./pages/AdminShansoLearnPage";
import AdminCourseEditorPage from "./pages/AdminCourseEditorPage";
import AdminBookPurchases from "./pages/admin/AdminBookPurchases";
import AdminWebsiteProjects from "./pages/admin/AdminWebsiteProjects";
import AdminQuotes from "./pages/admin/AdminQuotes";
import AdminSubscriptions from "./pages/admin/AdminSubscriptions";
import AdminAITools from "./pages/admin/AdminAITools";
import AdminAIFounder from "./pages/admin/AdminAIFounder";
import AdminAnnouncements from "./pages/admin/AdminAnnouncements";
import AdminPopups from "./pages/admin/AdminPopups";
import AdminPythonLab from "./pages/admin/AdminPythonLab";
import AdminLayout from "./components/AdminLayout";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";
import ContactUs from "./pages/ContactUs";
import LeadershipCapstonePage from "./pages/LeadershipCapstonePage";
import ChatWidget from "./components/ChatWidget";
import TutorPage from "./pages/TutorPage";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("admin_token");
  return token ? children : <Navigate to="/admin/login" replace />;
};

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Check URL fragment for session_id from Emergent OAuth - process before normal routing
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth/google" element={<GoogleAuthCallback />} />
      <Route path="/trainings/:id" element={<TrainingDetail />} />
      <Route path="/trainings/:id/register" element={<RegisterPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/book/:id/purchase" element={<BookPurchase />} />
      <Route path="/book-purchase-success" element={<BookPurchaseSuccess />} />
      <Route path="/read-book" element={<SimpleBookReader />} />
      <Route path="/book/:bookId/read-free" element={<FreeBookReader />} />
      <Route path="/download-book" element={<DownloadBook />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/website-services" element={<WebsiteServices />} />
      <Route path="/tutor" element={<TutorPage />} />
      <Route path="/subscriptions/:token" element={<SubscriptionRenewalPage />} />
      <Route path="/ai-tools" element={<AIToolsPage />} />
      <Route path="/ai-tools/call-analyzer" element={<CallAnalyzerPage />} />
      <Route path="/ai-tools/seo-services" element={<SeoServicesPage />} />
      <Route path="/ai-tools/sop-studio" element={<SopStudioPage />} />
      <Route path="/ai-tools/sop-studio/library" element={<SopLibraryPage />} />
      <Route path="/ai-tools/resume-ats" element={<ResumeAtsPage />} />
      <Route path="/ai-tools/resume-ats/library" element={<ResumeLibraryPage />} />
      <Route path="/courses" element={<CoursesCatalogPage />} />
      <Route path="/my-courses" element={<MyCoursesPage />} />
      <Route path="/courses/:slug" element={<CourseDetailPage />} />
      <Route path="/courses/:slug/access" element={<CourseAccessPage />} />
      <Route path="/courses/bundle/access" element={<BundleAccessPage />} />
      <Route path="/learn/:slug" element={<LearnPage />} />
      <Route path="/learn/qb-ai-for-leaders/capstone" element={<LeadershipCapstonePage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/ai-tools/python-lab" element={<PythonLabPage />} />
      <Route path="/ai-tools/python-lab/try" element={<TryLessonPage />} />
      <Route path="/ai-tools/python-lab/roadmap" element={<RoadmapPage />} />
      <Route path="/ai-tools/python-lab/module/:moduleSlug" element={<PythonLabModulePage />} />
      <Route path="/ai-tools/python-lab/lesson/:lessonSlug" element={<PythonLessonPage />} />
      <Route path="/showcase/python-lab" element={<ProjectShowcasePage />} />
      <Route path="/showcase/python-lab/:projectId" element={<ProjectShowcaseDetailPage />} />
      <Route path="/become-ai-founder" element={<AIFounderPage />} />
      <Route path="/verify-certificate/:certificateId" element={<VerifyCertificate />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <AdminLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="trainings" element={<AdminTrainings />} />
        <Route path="participants" element={<AdminParticipants />} />
        <Route path="certificates" element={<AdminCertificates />} />
        <Route path="testimonials" element={<AdminTestimonials />} />
        <Route path="news" element={<AdminNews />} />
        <Route path="books" element={<AdminBooks />} />
        <Route path="shanso-learn" element={<AdminShansoLearnPage />} />
        <Route path="shanso-learn/course/:course_id" element={<AdminCourseEditorPage />} />
        <Route path="book-purchases" element={<AdminBookPurchases />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        <Route path="website-analytics" element={<AdminWebsiteAnalytics />} />
        <Route path="website-projects" element={<AdminWebsiteProjects />} />
        <Route path="quotes" element={<AdminQuotes />} />
        <Route path="subscriptions" element={<AdminSubscriptions />} />
        <Route path="ai-tools" element={<AdminAITools />} />
        <Route path="python-lab" element={<AdminPythonLab />} />
        <Route path="ai-founder" element={<AdminAIFounder />} />
        <Route path="announcements" element={<AdminAnnouncements />} />
        <Route path="popups" element={<AdminPopups />} />
      </Route>
    </Routes>
  );
}

import { ScrollProgress } from "./components/Animations";

function App() {
  return (
    <BrowserRouter>
      <ScrollProgress />
      <ChatWidget />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
